import { CircleLoader } from "react-spinners";

export const SuspenseLoading = () => {
  return (
    <div className="loader">
      <CircleLoader color={"#91298c"} loading={true} />
    </div>
  );
};
